module.exports={
	"add": "Neues Projekt anlegen",
	"title": "Titel",
	"contest": "Wettbewerb"
}
